import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService } from '@app/services';

class VaultGroupsService {
    readonly apiBase: string = '/api/directory/Vaults';

    getVaultGroups(vaultId: string, orderBy: string, asc: string, top: number, skip: number, isReset: boolean): AxiosPromise {

        return apiService.get(`${this.apiBase}(${vaultId})/GroupsInVault`,
            {
                params: {
                    $orderBy: orderBy + ' ' + asc,
                    $top: top,
                    $skip: skip,
                    $count: isReset,
                }
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    };

    updateVaultGroupPermissions(updateObject: any, vaultId: string, handleSuccess: Function, handleError: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}(${vaultId})/UpdateGroupPermissions`,
            updateObject,
            {
                onSuccess: handleSuccess,
                onError: handleError
            })
            .catch();
    };

    addVaultGroups(ids: string[], vaultId: string, handleSuccess: Function, handleError: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}(${vaultId})/AddGroup`,
            {
                'Group': ids
            },
            {
                onSuccess: handleSuccess,
                onError: handleError
            })
            .catch();
    };

    removeVaultGroups(ids: string[], vaultId: string, handleSuccess: Function, handleError: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}(${vaultId})/DeleteVaultGroups`,
            {
                'VaultGroups': ids
            },
            {
                onSuccess: handleSuccess,
                onError: handleError
            })
            .catch();
    };
}

export const vaultGroupsService = new VaultGroupsService();
